import React, { useState } from 'react';

function DeleteUserModal({ isOpen, onClose, onConfirm, user }) {
  const [confirmText, setConfirmText] = useState('');
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (confirmText !== 'DELETE') return;
    
    setLoading(true);
    try {
      await onConfirm(user.id);
      onClose();
    } catch (err) {
      // Error handled in parent
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setConfirmText('');
    onClose();
  };

  if (!isOpen || !user) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content delete-user-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header delete-modal-header">
          <h2>⚠️ Delete User Account</h2>
          <button className="modal-close" onClick={handleClose}>&times;</button>
        </div>

        <div className="delete-modal-body">
          <div className="delete-warning">
            <p><strong>You are about to permanently delete this user:</strong></p>
            <div className="user-to-delete">
              <div className="user-delete-name">{user.name}</div>
              <div className="user-delete-email">{user.email}</div>
              <div className="user-delete-dept">Department: {user.department}</div>
            </div>
          </div>

          <div className="delete-consequences">
            <p><strong>This action will:</strong></p>
            <ul>
              <li>❌ Permanently delete the user's account</li>
              <li>❌ Remove all their Q&A history</li>
              <li>❌ Revoke their access immediately</li>
            </ul>
            <p className="warning-text">⚠️ This action cannot be undone!</p>
          </div>

          <div className="delete-confirm-input">
            <label>Type <strong>DELETE</strong> to confirm:</label>
            <input
              type="text"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value.toUpperCase())}
              placeholder="Type DELETE"
              className="form-input"
              disabled={loading}
            />
          </div>

          <div className="modal-actions">
            <button
              type="button"
              className="btn-cancel"
              onClick={handleClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn-delete-confirm"
              onClick={handleConfirm}
              disabled={confirmText !== 'DELETE' || loading}
            >
              {loading ? 'Deleting...' : '🗑️ Delete User'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeleteUserModal;
